// Action Text ships with attachment support switched on: Trix renders an
// "attach files" toolbar button and accepts dragged and pasted files, each of
// which uploads through Active Storage's direct-upload endpoint. No form on
// this site has any use for attachments, and that endpoint is refused outright
// (see config/routes.rb), so the editors are configured without them.
//
// `trix-file-accept` is the one event every attachment path funnels through,
// so cancelling it covers the toolbar button, drag-and-drop and paste alike.
// The button group goes too -- an editor should not offer a control that
// silently does nothing.
addEventListener("trix-file-accept", (event) => event.preventDefault())

addEventListener("trix-initialize", (event) => {
  event.target.toolbarElement
    ?.querySelector('[data-trix-button-group="file-tools"]')
    ?.remove()
})
